<template>
  <v-container v-if="is_self_route" style="height: 100%">
    <v-card flat>
      <v-card-title class="title style-color-main-gray">
        <span>Мои записи </span>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
                v-on="on"
                class="mr-2"
                medium
                @click="getItems()"
            >
              update
            </v-icon>
          </template>
          <span>Обновить данные</span>
        </v-tooltip>
      </v-card-title>
      <v-data-table
          :footer-props="{'items-per-page-options':[10, 25, 50], 'items-per-page-text': 'Число элементов'}"
          :headers="headers"
          :items="items"
          :items-per-page.sync="pagination.size"
          :page.sync="pagination.page"
          :server-items-length="pagination.count"
          no-data-text="Данные отсутствуют"
          no-results-text="Ничего не было найдено"
      >
        <template v-slot:item.event="{ item }" >
          <router-link   :to="goChildren(item)">
            {{ item.event.name }}
          </router-link>
        </template>
        <template v-slot:item.day="{ item }">
          {{displayDate(item.day)}}
        </template>
        <template v-slot:item.interval="{ item }">
          {{ item.interval.started }} - {{ item.interval.ended }}
        </template>
        <template v-slot:item.canceled="{ item }">
          <v-icon v-if="item.canceled">done</v-icon><v-icon v-else>clear</v-icon>
        </template>
        <template v-slot:item.is_visited="{ item }">
          <v-icon v-if="item.is_visited">done</v-icon><v-icon v-else>clear</v-icon>
        </template>

        <template v-slot:no-data>
          <v-card-text>Данные не загружены</v-card-text>
        </template>

      </v-data-table>
    </v-card>
    <v-dialog v-model="opened_confirm" persistent width="500">
      <v-card v-if="deletable">
        <v-card-title>Подтвердите отмену записи</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Вы уверены что хотите отменить запись ?<br>
        </v-card-text>
        <v-card-actions>
          <v-flex>
            <v-btn
                color="warning"
                text
                @click="deleteItem(deletable)"
            >
              Удалить
            </v-btn>
            <v-btn
                text
                @click="closeConfirmDelete"
            >Отмена
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
  <router-view v-else></router-view>
</template>


<script>
import UserDataMixin from '@/mixins/UserDataMixin'
import {loadData, makeDeleteRequest} from "@/helper/requests";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";

import urls from '@/urls/helper.js'

import names from "@/modules/recording/routers/names";
import {displayDate} from "../../../../../helper";



export default {
  name: "List",
  mixins: [
    PaginatedDataMapperMixin,
    UserDataMixin
  ],
  components: {

  },

  computed: {
    is_self_route: function () {
      return this.$route.name === names.PUBLIC.MYEVENTS
    },
  },
  data() {
    return {
      URL_LIST: urls.getRecordingUrlWithParameters('user|event|records-list', 'get'),
      URL_DELETE: urls.getRecordingUrlWithParameters('token|event|records-detail', 'destroy'),
      search: '',
      items: [],
      singleExpand: false,
      selectors: {
        parentCategory: [],
      },
      loading: true,
      headers: [
        {text: 'Событие', sortable: false, align: 'left', value: "event",},
        {text: 'Дата', sortable: false, align: 'left', value: "day",},
        {text: 'Интервал', sortable: false, align: 'left', value: "interval",},
        {text: 'Почта', sortable: false, align: 'left', value: "email",},
        {text: 'Отменено', sortable: false, align: 'left', value: "canceled",},
        {text: 'Посещено', sortable: false, align: 'left', value: "is_visited",},
      ]
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    displayDate,
    goChildren(item){
      return {name: names.PUBLIC.TOKEN,params:{ code: item.code}}
    },
    deleteItem: function (val) {
      makeDeleteRequest(
          urls.getRecordingUrlWithParameters('event|records-detail', 'destroy', {id: val.id, event: val.event.id})
      ).then(resp => {
        this.closeConfirmDelete()
        if (resp.ok) {
          this.getItems()
        }

      })
    },
    addItem() {
      this.closedForm()
      this.load();
    },
    refreshItem() {
      this.closedForm()
      this.load();
    },
    getItems() {
      this.load();
    },
    loadData(url = undefined) {
      this.load(url);
    },
    load: function (url = undefined) {
      this.setLoading();
      if (url === undefined)
        url = this.URL_LIST;
      loadData(
          url,
          (data) => {
            this.mapPagination(data);
            this.mapResults(data, 'items');
            this.setCurrentLoadUrl(url);
            this.setNotLoading();
          }
      )
    },
  }
}
</script>
<style scoped>
</style>
